import { z } from 'zod';

export const LoyaltyConfigDTO = z.object({
    enableOffers: z.boolean().optional(),
    enableLoyaltyPoints: z.boolean().optional().default(true),
    loyaltyProgramName: z.string().optional(),
});

export type LoyaltyConfigDTO = z.infer<typeof LoyaltyConfigDTO>;
